export const TC = "tc"; // Traditional Chinese
export const EN = "en";
export const phoneNo = "+852 9223 5834"
export const emailAddress = "cs@mediconcen.com"